import React from "react";
import { useArraySubFormContext } from "./ArraySubFormContext";

interface Props {
  render: (append: (newItem?: any) => void) => React.ReactNode;
}

const ArraySubFormAdd: React.FC<Props> = ({ render }) => {
  const { append } = useArraySubFormContext();
  return <>{render(append)}</>;
};

export default ArraySubFormAdd;
